import { useEffect } from "react";
import { HStack, VStack } from "@chakra-ui/react";
import Header from "./header";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";
import { getDocumentTitle } from "../route_titles";

const PageContainer = observer(({ children }) => {
  const location = useLocation();

  useEffect(() => {
    document.title = getDocumentTitle(location.pathname);
  }, [location.pathname]);

  // Проверяем, находимся ли мы на странице логина
  const isLoginPage = location.pathname === "/";

  return (
    <VStack w="100%" align="stretch" spacing={0}>
      {/* Показываем Header только если не страница логина */}
      {!isLoginPage && <Header />}

      <HStack
        width={"100%"}
        minH={"100vh"}
        align={"flex-start"}
        spacing={0} // Убираем стандартные отступы, если нужно
      >
        {children}
      </HStack>
    </VStack>
  );
});

export default PageContainer;
